import { UserSessionService } from './../UserSession/user-session.service';
import { NbMenuItem } from '@nebular/theme';

export const MAIN_MENUS_BY_DEFAULT =
  [
    {
       "menu":"informes",
       "title":"Informes",
       "icon":{
               "pack":"eva",
               "icon":"file-text-outline"
              }
    },
    {
       "menu":"mapas",
       "title":"Mapas",
       "icon":{
               "pack":"eva",
               "icon":"map-outline"
               }
    },
    {
       "menu":"visor",
       "title":"Visor",
       "icon":{
               "pack":"eva",
               "icon":"compass-outline"
              }
    },
    {
       "menu":"clima",
       "title":"Clima",
       "icon":{
           "pack":"eva",
           "icon":"sun-outline"
       }
    },
    {
       "menu":"entidades",
       "title":"Entidades",
       "icon":{
          "pack":"font-awesome",
          "icon":"tasks"
       }
    }
 ]


export const ENTITIES_CHILDREN_DEFAULT = [
  {
    title:'Productos',
    identifier:'Productos',
    tipo: 2,
    icon: {
      icon:'pump-medical',
      pack:'font-awesome',
    },
    link:'/pages/ajustes/product',
  },
  {
    title:'Maquinaria',
    identifier:'Maquinaria',
    tipo: 3,
    icon: {
      icon:'tractor',
      pack:'font-awesome',
    },
    link:'/pages/ajustes/machinery',
  },
  {
    title:'Plagas/Enfermedades',
    identifier:'Plagas',
    tipo: 4,
    icon: {
      icon:'bug',
      pack:'font-awesome',
    },
    link:'/pages/ajustes/disease',
  },
  {
    title:'Mantenimientos',
    identifier:'maintenances',
    tipo: 5,
    icon: {
      icon:'toolbox',
      pack:'font-awesome',
    },
    link:'/pages/ajustes/maintenance',
  },
  {
    title:'Parcelas',
    identifier:'fields',
    tipo: 1,
    icon: {
      icon:'draw-polygon',
      pack:'font-awesome',
    },
    link:'/pages/ajustes/field',
  },
]

export const MENU_ITEMS_BY_ROLE ={

  'superadmin' : [
    {
      title: 'Compañías',
      icon: 'home-outline',
      link: '/pages/company',

    },
    {
      title: 'Usuarios',
      icon: 'people-outline',
      link: '/pages/usuarios/0',

    },
    {
      title: 'Card-Links',
      icon: 'globe-outline',
      link: '/pages/framelinks/0',

    },
    {
      title: 'Entidades',
      icon: 'settings-2-outline',
      link: '/pages/customentities',

    },
    {
      title: 'Configuración',
      icon: 'options-2-outline',
      expanded: true,
      children: [
        {
          title: 'Custom Forms',
          icon: 'file-text-outline',
          link: '/pages/customforms',
        },
      ]
    }
  ],
  'manager' : [

    {
      title: 'Informes',
      menuId:'informes',
      icon: 'file-text-outline',
      expanded:false,
      children: [
        {
          title:'Plagas',
          icon: {
                  icon:'bug',
                  pack:'font-awesome',
                },
          link: '/pages/informes/disease',
        },
        {
          title:'Mantenimientos',
          icon: {
            icon:'toolbox',
            pack:'font-awesome',
          },
          link: '/pages/informes/maintenance',
        },
        {
          title:'Muestreos',
          icon: {
            icon:'vials',
            pack:'font-awesome',
          },
          link: '/pages/informes/sampling',
        },
        {
          title:'Cuaderno de Campo',
          icon: {
            icon:'clipboard',
            pack:'font-awesome',
          },
          link: '/pages/informes/notebook',
        },
      ],

    },
    {
      title: 'Mapas',
      menuId:'mapas',
      icon: 'map-outline',
      expanded: false,
      children:[
        {
          title: 'Visor',
          icon : 'compass-outline',
          link: '/pages/visorinformemapa',
        },


      ],

    },
    {
      title: 'Clima',
      menuId:'clima',
      icon: 'sun-outline',
      expanded: false,
      children:[
        {
          title:'Vetunsky',
          icon: 'arrow-ios-forward-outline',
          link:'/pages/viewframelink/'+encodeURIComponent('https://www.ventusky.com/'),
        }
      ],

    },
    {
      title: 'Entidades',
      menuId:'entidades',
      icon: {
        icon:'tasks',
        pack:'font-awesome',
      },
      expanded:false,
      children: ENTITIES_CHILDREN_DEFAULT
    }

  ],
  'reporter' : [
    {
      title: 'Informes',
      menuId:'informes',
      icon: 'file-text-outline',
      link: '/pages/cardlinks',

    },
  ],

}



export function getMenuByUser(user: any): NbMenuItem[]{
    let menu = [];

    user.acl_roles.forEach((role) => {
      menu = menu.concat(MENU_ITEMS_BY_ROLE[role]);

    });
    return menu;
}


export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'home-outline',
    link: '/pages/dashboard',
    home: true,
  },
  {
    title: 'FEATURES',
    group: true,
  },
  {
    title: 'Auth',
    icon: 'lock-outline',
    children: [
      {
        title: 'Login',
        link: '/auth/login',
      },
      {
        title: 'Register',
        link: '/auth/register',
      },
      {
        title: 'Request Password',
        link: '/auth/request-password',
      },
      {
        title: 'Reset Password',
        link: '/auth/reset-password',
      },
    ],
  },
];
